export default "__VITE_ASSET__Bjc4_oNI__"